"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetAccountsFromShop;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _dicts = require("@package/dicts");

var _react = require("react");

function useGetAccountsFromShop(shop) {
  return (0, _react.useMemo)(function () {
    var currency = [];

    if (shop) {
      var accounts = shop['accounts'];

      if (accounts) {
        for (var key in _dicts.currencies) {
          if (_dicts.currencies.hasOwnProperty(key)) {
            var defaultCurrency = _dicts.currencies[key];

            if (defaultCurrency['id'] in accounts) {
              var available = accounts[defaultCurrency['id']]['available'];

              if (available > 0) {
                currency.push((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _dicts.currencies[key]), {}, {
                  name: defaultCurrency['id'],
                  available: accounts[defaultCurrency['id']]['available']
                }));
              }
            }
          }
        }
      }
    }

    return currency;
  }, [shop]);
}